import { invisiblyApi } from 'src/redux/api/invisibly-api';
import { APITagType } from 'src/redux/api/invisibly-api.types';
import type { UserJourney, UserJourneySessionDetail } from '../types/user-journey.types';

const USER_JOURNEY_PROXY_TIMEOUT_MS = 90_000;

const userJourneyEndpoints = invisiblyApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserJourney: builder.query<UserJourney, string>({
      query: (userId) => ({
        method: 'GET',
        url: `b2b/manage/user-journey/${userId}`,
        handleErrorGlobally: false,
        timeout: USER_JOURNEY_PROXY_TIMEOUT_MS,
      }),
      providesTags: (_result, _error, userId) => [{ id: userId, type: APITagType.UserJourney }],
    }),
    getUserJourneySession: builder.query<
    UserJourneySessionDetail,
    { userId: string; sessionIndex: number }
    >({
      query: ({ userId, sessionIndex }) => ({
        method: 'GET',
        url: `b2b/manage/user-journey/${userId}/sessions/${sessionIndex}`,
        handleErrorGlobally: false,
        timeout: USER_JOURNEY_PROXY_TIMEOUT_MS,
      }),
      providesTags: (_result, _error, { userId, sessionIndex }) => [
        { id: `${userId}-${sessionIndex}`, type: APITagType.UserJourney },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetUserJourneyQuery,
  useGetUserJourneySessionQuery,
  useLazyGetUserJourneySessionQuery,
} = userJourneyEndpoints;

export { isPortalSyncNotConfiguredError } from 'src/features/manage-clients/users/endpoints/portal-users.endpoints';
